import { useEffect, useState } from "react";
import { add, format, isAfter } from "date-fns";
import { Tag } from "../typings/contract";
import useLocalStorage from "./useLocalStorage";
import NormalizerApi from "../api/NormalizerApi";
import packageJson from "../../package.json";
const PACKAGE_VERSION = packageJson.version;

// --- jednoduchá cache (mimo hook) ---
let sharedTags: Tag[] | null = null;
let sharedExpiry: string | null = null;
let fetchPromise: Promise<void> | null = null;

interface ContractTagsReturnProps {
  isLoading: boolean;
  isError: boolean;
  tags: Array<Tag>;
  expiryDate: string;
}

const useContractTags = (): ContractTagsReturnProps => {
  const currentTime = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss");
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [tagsExpiration, setTagsExpiration] = useLocalStorage<string>("tagsExpiration" + PACKAGE_VERSION, currentTime);
  const [localStorageTags, setLocalStorageTags] = useLocalStorage<Array<Tag>>("tags" + PACKAGE_VERSION, []);

  useEffect(() => {
    const shouldFetch =
      !Boolean(localStorageTags.length) ||
      isAfter(new Date(), new Date(tagsExpiration));

    const fetchTags = async () => {
      if (sharedTags && sharedExpiry && !shouldFetch) {
        // máme cache a není expirovaná
        setIsLoading(false);
        return;
      }

      if (!fetchPromise) {
        fetchPromise = NormalizerApi.getTagsList()
          .then((tags) => {
            sharedTags = tags;
            sharedExpiry = format(add(new Date(), { hours: 12 }), "yyyy-MM-dd'T'HH:mm:ss");
            setLocalStorageTags(tags);
            setTagsExpiration(sharedExpiry);
            setIsError(false);
          })
          .catch(() => {
            setIsError(true);
          })
          .finally(() => {
            setIsLoading(false);
            fetchPromise = null;
          });
      } else {
        // počkáme na probíhající fetch
        fetchPromise.finally(() => setIsLoading(false));
      }
    };

    fetchTags();
  }, []);

  return {
    isLoading,
    isError,
    tags: sharedTags ?? localStorageTags,
    expiryDate: sharedExpiry ?? tagsExpiration,
  };
};

export default useContractTags;
